import { Routes, Route, Link } from "react-router-dom";
import { APITester } from "./APITester";
import "./index.css";

import logo from "./logo.svg";
import reactLogo from "./react.svg";
import { Base64 } from "./tools/Base64";
import { SearchTools } from "./tools/SearchTools";
import { JSONFormatter } from "./tools/JSONFormatter";

function Home() {
  return (
    <div className="app">
      <div className="logo-container">
        <img src={logo} alt="Bun Logo" className="logo bun-logo" />
        <img src={reactLogo} alt="React Logo" className="logo react-logo" />
      </div>

      <h1>Bun + React</h1>
      <p>
        Edit <code>src/App.tsx</code> and save to test HMR
      </p>
    </div>
  );
}

export function App() {
  return (
    <>
      <header>
        <nav>
          <Link to="/">Home</Link> | 
          <Link to="/api-tester">API Tester</Link> |
          <Link to="/tools/base64">Base64 Tool</Link> |
          <Link to="/tools/json">JSON Formatter</Link> |
          <Link to="/tools/search">Search Tools</Link>
        </nav>
      </header>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/api-tester" element={<APITester />} />
        <Route path="/tools/base64" element={<Base64/>} />
        <Route path="/tools/json" element={<JSONFormatter />} />
        <Route path="/tools/search" element={<SearchTools />} />
      </Routes>
    </>
  );
}

export default App;